import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44bcacb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gray-header" }
const _hoisted_2 = { class: "t-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gray-header-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://static.wecity.qq.com/miying/miying-logo-a789079f5294e3e40a12865210765e55.png",
    alt: "",
    class: "gray-header-logo__img"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "gray-header-logo__text" }, "2021 “觅影”医学人工智能算法大赛")
], -1))
const _hoisted_4 = { class: "gray-header-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", {
          class: _normalizeClass(["gray-header-item", _ctx.activeName === 'Home' ? 'active' : '']),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleClick('/')))
        }, "首页", 2),
        _createElementVNode("li", {
          class: _normalizeClass(["gray-header-item", _ctx.activeName === 'Faq' ? 'active' : '']),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleClick('/faq')))
        }, "常见问题", 2),
        (_ctx.hasAudit)
          ? (_openBlock(), _createElementBlock("li", {
              key: 0,
              class: _normalizeClass(["gray-header-item", _ctx.activeName === 'PersonalInfo' ? 'active' : '']),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleClick('/personalInfo')))
            }, " 个人中心 ", 2))
          : _createCommentVNode("", true),
        (!_ctx.hasLogin)
          ? (_openBlock(), _createElementBlock("li", {
              key: 1,
              class: "gray-header-item",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleLogin && _ctx.handleLogin(...args)))
            }, "登录"))
          : _createCommentVNode("", true),
        (_ctx.activeName === 'ChannelDetail')
          ? (_openBlock(), _createElementBlock("li", {
              key: 2,
              class: _normalizeClass(["gray-header-item", _ctx.activeName === 'ChannelDetail' ? 'active' : ''])
            }, "赛道详情", 2))
          : _createCommentVNode("", true),
        (_ctx.activeName === 'FlowDetail')
          ? (_openBlock(), _createElementBlock("li", {
              key: 3,
              class: _normalizeClass(["gray-header-item", _ctx.activeName === 'FlowDetail' ? 'active' : ''])
            }, "详细信息", 2))
          : _createCommentVNode("", true),
        (_ctx.hasLogin && !_ctx.hasAudit && (_ctx.raceInfo?.hasModify || _ctx.raceInfo?.hasAdd))
          ? (_openBlock(), _createElementBlock("li", {
              key: 4,
              class: _normalizeClass(["gray-header-item", _ctx.activeName === 'PersonalCenter' ? 'active' : '']),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleClick('/personalCenter')))
            }, " 报名参赛 ", 2))
          : _createCommentVNode("", true),
        (_ctx.hasLogin)
          ? (_openBlock(), _createElementBlock("li", {
              key: 5,
              class: "gray-header-item",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)))
            }, "退出登录"))
          : _createCommentVNode("", true)
      ])
    ])
  ], 512)), [
    [_vShow, !_ctx.notShowName.includes(_ctx.activeName)]
  ])
}